import i18next from "i18next";
import Attribute, { MODE } from '../../components/attributes/Attributes';
import EAIcon from '../../components/common/EAIcon';
import { EANoData } from '../../components/common/EANoData';
import { useGetOffsetSize } from '../../components/hook/useGetOffsetSize';
import { formatDate } from '../../services/common/Utils';
import useStyles from "../../style/js-style/containers/thirdparties/sheet/attributes/AttributeValuesDataTableStyle.js";

function AttributeValues({attributes, openEditDialog, canEditAttribute, bondType, setSelectedAttribute, selectedAttribute, id, fetchAttributeValuesList, onUpdateSuccess = () => {}}) {
  const { classes } = useStyles();
  const [myRef, size] = useGetOffsetSize();

  function getAttributeDate(attributes) {
    return formatDate(
      attributes
        .flatMap(attribute => [attribute.updateDate, attribute.creationDate])
        .filter(date => date != null)
        .sort((a, b) => new Date(b) - new Date(a))[0]
    );
  }

  return (
    <div className={attributes.length > 0 ? classes.attributeValuesRoot : classes.attributeValuesNoData} ref={myRef}>
      {/* Date */}
      {attributes.length > 0 && getAttributeDate(attributes) &&
        <div className={classes.attributeItemDate}>
          <EAIcon icon={"calendar"} className={classes.attributeDateIcon} />
          <div className={classes.attributeItemDateModifyLabel}>
            {i18next.t("updated")} :
          </div>
          <div className={classes.attributeItemDateModifyDate}>
            {getAttributeDate(attributes)}
          </div>
        </div>
      }

      {attributes.length > 0 ? attributes.map((attribute, index) => {
        return (
          <Attribute
            key={index}
            mode={MODE.edit}
            attribute={attribute}
            index={index}
            openEditDialog={openEditDialog}
            canEditAttribute={canEditAttribute}
            isEditAttribute={selectedAttribute?.index === index}
            setSelectedAttribute={setSelectedAttribute}
            bondType={bondType}
            id={id}
            fetchAttributeValuesList={fetchAttributeValuesList}
            sizeOfWrapper={size}
          />
        )})

        // Pas de data
        : (
          <div
            className={classes.noDataRootThird}
          >
            <EANoData
              icon={"noAttributes-" + bondType}
              label={i18next.t("attributes.noAttribute", {
                type: i18next.t("attributes." + bondType),
              })}
            />
          </div>
        )}
    </div>
  )
}

export default AttributeValues;
